import { render, staticRenderFns } from "./ItemsAmount.vue?vue&type=template&id=822c2be4&scoped=true&"
import script from "./ItemsAmount.vue?vue&type=script&lang=js&"
export * from "./ItemsAmount.vue?vue&type=script&lang=js&"
import style0 from "./ItemsAmount.vue?vue&type=style&index=0&id=822c2be4&prod&lang=css&"
import style1 from "./ItemsAmount.vue?vue&type=style&index=1&id=822c2be4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822c2be4",
  null
  
)

export default component.exports